import {
  PSPBenefit,
  BENEFIT_TYPE,
  ManualMedicine,
  Medicine,
  PT_PRESCRIPTION_TYPE,
  StructuredPacking,
  OriginEnum,
} from '../../../interfaces/medicine';
import { Exam, LATERALITY } from '../../../interfaces/exam';
import { ModelDetails, PrescriptionHistory } from '../../my-central/services';
import { Prescription } from '../../../interfaces/prescription';
import { Certificate, CERTIFICATES, CERTIFIER_STATUS } from '../../certificate/certificates';
import {
  OwnedCertificate,
  PDFModelLayout,
  PrescriberConfiguration,
  PrescriberConfigurations,
} from '../../../shared/prescriber';
import { MedicalCertificate, MEDICAL_CERTIFICATE_DOCUMENT_TYPE } from '../../../interfaces/medicalCertificate';
import { PrescriptionDocuments, PrescriptionInteractionJustifyDetail, SeverityDetails, SMRForm } from '../service';
import { Documents } from '../pdfService';
import { MedicalReferral, Specialty } from '../../../interfaces/MedicalReferral';
import { MedicinesInteractions } from '../../../interfaces/medicine-drug-interactions';
import { LacunaDocumentValidation } from '../../certificate/lacunaService';
import { MedicalReport } from '../../../interfaces/medicalReport';
import { BasicMedicine } from '../../../components/search/basicMedicine';
import { Formula } from '../../../interfaces/formula';

export const DEFAULT_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 123,
  Posologia: 'Tomar 1 gota via oral',
  Quantidade: 1,
  Embalagem: 24,
  Embalagens: ['1', '2', '3', '24'],
  UsoContinuo: false,
  LaboratorioPreferencia: 0,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: [],
  DetalhesDispensa: [],
  IdMedicamento: 11413,
  Nome: 'DORFLAN',
  Concentracao: '15',
  // ConcentracaoComUnidade: '15 MG/ML',
  Unidade: 'MG/ML',
  Farmacos: ['DICLOFENACO DIETILAMONIO'],
  PrincipiosAtivos: [
    {
      Nome: 'DICLOFENACO DIETILAMONIO',
      CAS: '78213-16-8',
    },
  ],
  Grupo: 'ANTI-INFLAMATÓRIOS',
  TipoMedicamento: 'SIMILAR',
  TipoMedicamentoComAcentuacao: 'SIMILAR',
  FormaFarmaceutica: 'Suspensao Oral (Gotas)',
  FormaFarmaceuticaComAcentuacao: 'Suspensão Oral (Gotas)',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0.0,
  PodeDispensaEletronica: true,
  idPortaria344: 0,
  IdViaAdministracao: 0,
  CodigoATC: 'M01AB05',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: true,
  Label: 'DORFLAN 15 MG/ML - Suspensão oral (gotas)',
  LabelFarmaco: 'DORFLAN 15 MG/ML - Suspensão oral (gotas)',
  LME: false,
  ProdutoCorrelato: false,
  Beneficios: [DEFAULT_BENEFIT()],
  QuantidadeUnidadeFormatada: '1 caixa com 24 unidades',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_BASIC_MEDICINE = (): BasicMedicine => ({
  Posologia: 'Tomar 1 gota via oral',
  Quantidade: 1,
  Embalagem: 24,
  UsoContinuo: false,
  ImpressaoDuasVias: false,
  IdMedicamento: 1141,
  Antimicrobiano: false,
  idPortaria344: 0,
  IdViaAdministracao: 0,
  MIP: false,
  Label: 'DORFLAN 15 MG/ML - Suspensão oral (gotas)',
  ProdutoCorrelato: false,
  QuantidadeUnidadeFormatada: '1 caixa com 24 unidades',
});

export const DEFAULT_MANUAL_MEDICINE = (): ManualMedicine => ({
  QuantidadeDispensada: null,
  Posologia: 'Tomar 2 vezes ao dia de 6 em 6 horas',
  Nome: 'Medicamento',
  Manual: true,
  Label: 'Medicamento que não existe na base',
  idPrescricaoMedicamentoManual: 123,
  idMedicamentoManual: 321,
  Dispensado: false,
  DetalhesDispensa: [],
  UsoContinuo: false,
  Embalagem: 12,
  Quantidade: 1,
  UsoInterno: false,
  LME: false,
  ProdutoCorrelato: false,
  QuantidadeUnidadeFormatada: '1 caixa com 12 unidades',
  Ordem: 1,
  Manipulado: false,
  TipoReceita: PT_PRESCRIPTION_TYPE.SIMPLES,
});

export const DEFAULT_MEDICAL_REPORT = (): MedicalReport => ({
  idPrescricaoLaudoMedico: 123,
  Texto: 'I see dead people',
  Titulo: 'Laudo',
  DataLaudoMedico: '2022-12-13T17:44:21.567Z',
  DataModificacao: '2022-12-13T17:44:21.567Z',
  DataInclusao: '2022-12-13T17:44:21.567Z',
});

export const DEFAULT_SOCIAL_NAME = 'Ken Adams';

export const DEFAULT_PRESCRIPTION = (hasSocialName: boolean = false): Prescription => ({
  Itens: [],
  ItensManuais: [],
  NecessitaNotificacaoReceitaPapel: false,
  Formulas: [],
  RQESelecionado: null,
  DataCriacao: new Date(2020, 0, 1),
  ReferenciaInterna: '1182664001216',
  Prescritor: {
    Documento: '44575547077',
    Nome: 'Dr Médico da Silva',
    idPrescritor: 1,
    UFConselho: 'SP',
    Numero: 'NX1234',
    Conselho: 'CRM',
    UF: 'SP',
    Sexo: '',
    Especialidades: ['PEDIATRIA'],
    RQEs: [
      {
        idMedicoRqe: 1,
        textoSimples: 'CARDIOLOGIA - RQE Nº: 34791',
        textoCompleto: 'CARDIOLOGIA - RQE Nº: 34791 (Áreas de atuação: Ecocardiografia - RQE Nº: 34792)',
        ativo: true,
      },
      {
        idMedicoRqe: 2,
        textoSimples: 'CLÍNICA MÉDICA - RQE Nº: 52096',
        textoCompleto: 'CLÍNICA MÉDICA - RQE Nº: 52096',
        ativo: true,
      },
    ],
    Email: 'medicosilva@mevosaude.com.br',
  },
  Paciente: {
    Nome: 'João da Silva Oliveira',
    NomeSocial: hasSocialName ? DEFAULT_SOCIAL_NAME : undefined,
    Nascimento: '1990-01-01T00:00:00',
    Sexo: 'NI',
    Endereco: {
      Endereco1: 'Av. Rondon Pacheco, 1',
      Endereco2: '',
      Bairro: 'Centro',
      Cidade: 'São Paulo',
      Estado: 'SP',
      CodigoPostal: '12345678',
      Numero: '123',
    },
    AlergiasEstruturadas: [],
    Alergias: [],
    Peso: 0,
    Altura: 0,
    ReferenciaExterna: '07803583-1043118',
    Idade: '6 Anos 3 Meses 11 Dias',
    idPaciente: 216510,
    Responsaveis: [],
    Emails: [],
    Telefones: [],
    CID10Estruturado: [],
    Documento: '12345678909',
    Fumante: false,
    Gestante: false,
    Lactante: false,
  },
  Origem: {
    Nome: 'Minha Origem',
    idParceiro: 1,
    idProntuario: 1,
  },
  Estabelecimento: {
    idEstabelecimento: 1,
    Nome: 'Estabelecimento teste',
    CNES: '',
    Endereco: {
      Endereco1: 'Av. Rondon Pacheco, 1 - Bela Vista - São Paulo - SP, 123456-123',
      Endereco2: '',
      Cidade: 'Sao Paulo',
      Estado: 'SP',
      CodigoPostal: '12345678',
      Bairro: 'Bela Vista',
      Numero: '',
    },
    Logo: 'https://clinica/logo.png',
  },
  idPrescricaoStatus: 1,
  idPrescricao: 429041,
  TemBeneficio: false,
  Tags: [],
  RequerReceituarioEspecial: false,
  PrescricaoAssinada: false,
  CodigoValidacao: 'NX12345',
  URLBarCode: '',
  URLQRCode: 'https://qrcodes/qrcode.png',
  UltimoMetodoAssinatura: CERTIFICATES.MANUAL,
  Exames: [],
  CertificadoDigitalObrigatorio: false,
  PlanosDesconto: [],
  ExibirCertificadoLocal: true,
  ExibirEmailParaEnvio: true,
  PermitirImpressao: true,
  CorPrimaria: '#4cd137',
  CorSecundaria: '#fbc531',
  LogoURL: 'https://logos.com/logo.png',
  CIDS10Estruturados: [],
  Diagnosticos: [],
  ExibirPorPrincipioAtivo: false,
  Documentos: [],
  Encaminhamentos: [],
  PodeFiltrarRemume: false,
  PodeFiltrarRename: false,
  Atestado: null,
  Atestados: [],
  Relatorios: [],
  UrlPacientes: '',
  idPrescritor: 12345,
});

export const PRESCRIPTION_WITH_ITEMS = (): Prescription => ({
  ...DEFAULT_PRESCRIPTION(),
  idPrescricao: 429042,
  Itens: [DEFAULT_MEDICINE(), DEFAULT_MEDICINE()],
  ItensManuais: [DEFAULT_MANUAL_MEDICINE(), DEFAULT_MANUAL_MEDICINE()],
  Exames: [DEFAULT_EXAM(), DEFAULT_EXAM()],
  Atestado: DEFAULT_MEDICAL_CERTIFICATE(),
  Atestados: [DEFAULT_MEDICAL_CERTIFICATE(), DEFAULT_MEDICAL_CERTIFICATE()],
  Encaminhamentos: [DEFAULT_MEDICAL_REFERRAL(), DEFAULT_MEDICAL_REFERRAL()],
  Relatorios: [DEFAULT_MEDICAL_REPORT()],
  Comentario: 'hello',
});

export const DEFAULT_PARTNER_FEATURES = (): PrescriberConfiguration => ({
  idParceiro: 1,
  Nome: 'Minha Prescrição',
  Login: 'minhaprescricao',
  UltimoAcesso: new Date(2020, 0, 1),
  Bloqueado: false,
  NumeroTentativas: 0,
  idProntuarioEletronico: 9,
  ExibirObservacoes: true,
  HabilitarExame: true,
  HabilitarAtestado: true,
  EnviarSMSPrescricao: true,
  AssinarViaProntuario: false,
  RemoverOpcaoAssinatura: false,
  HabilitarSalvarSemEnviar: false,
  BloquearEdicaoCadastroPaciente: false,
  Features: {
    enableVerifyHistoryDocumentSignature: true,
    enableInteractionJustify: true,
    blockWhatsAppWeb: false,
    pdfVersion: 'workspace',
    enableReferral: true,
    enableOnlinePurchase: true,
    shareMedicalHistory: true,
    enablePrintValidation: true,
    enableCustomPdfLayout: true,
    enableGetDocuments: true,
    enablePdfDoctorNameSwitch: true,
    enablePdfDoctorRqeSwitch: true,
    enablePdfCustomLayout: true,
    enablePrescriptionSummary: true,
    enableGamefication: true,
  },
  PrimeiroAcesso: false,
  PoliticasDePrivacidade: '',
});

export const DEFAULT_FORMULA = (): Formula => ({
  id: 123,
  formulaName: 'Fórmula 1',
  prescriptionType: 'SIMPLES',
  physicalForm: 'COMPRIMIDO',
  quantity: 1,
  measure: 'MG',
  composition: 'COMPRIMIDO',
  posology: 'Injetar via intravenosa',
  doctorId: 123,
});

export const DEFAULT_EXAM = (): Exam => ({
  idPrescricaoExame: 123,
  idEzOrder: 123465,
  Nome: 'Acromioplastia - procedimento videoartroscópico de ombro',
  CodigoTUSS: '30735033',
  LadoRequerido: false,
  AnestesiaRequerida: false,
  Label: 'Acromioplastia - procedimento videoartroscópico de ombro',
  Instrucoes: '',
  AplicarAnestesia: false,
  CID10Estruturado: [],
  Lateralidade: LATERALITY.BOTH,
  categoria: 'blood',
  idExterno: '12345',
  examId: '123456',
  sigtap: '',
  tipoFormulario: null,
  tipoExameFormulario: [
    {
      idTipoExameFormulario: 1,
      Chave: 'FORMULARIO_APAC',
      Nome: 'APAC',
    },
    {
      idTipoExameFormulario: 2,
      Chave: 'FORMULARIO_BPA-I',
      Nome: 'BPA-I',
    },
  ],
  referencia: 'ref-123',
  ReferenciaExterna: null,
  OrigemExame: null,
  Origem: OriginEnum.MEDFLOW,
  customExamIndex: null,
});

export const DEFAULT_MODEL_DETAIL = (): ModelDetails => ({
  idPrescricao: 123,
  Medicamento: [DEFAULT_MEDICINE()],
  Formulas: [DEFAULT_FORMULA()],
  Exame: [DEFAULT_EXAM()],
  MedicamentoManual: [],
  Nome: 'Default Model',
  Atestados: null,
  Encaminhamentos: [DEFAULT_MEDICAL_REFERRAL()],
  Relatorios: null,
});

export const DEFAULT_PHARMA_MODEL_DETAIL = (): ModelDetails => ({
  idPrescricao: 123,
  Medicamento: [DEFAULT_MEDICINE()],
  Formulas: [DEFAULT_FORMULA()],
  Exame: [DEFAULT_EXAM()],
  Encaminhamentos: [DEFAULT_MEDICAL_REFERRAL()],
  MedicamentoManual: [],
  Nome: 'Default Pharma Model',
  Atestados: [DEFAULT_MEDICAL_CERTIFICATE()],
  Relatorios: null,
});

export const DEFAULT_MEDICAL_CERTIFICATE = (): MedicalCertificate => ({
  idPrescricaoAtestado: 1018362,
  DataInicio: '2021-05-10T00:00:00',
  DataTermino: '2021-05-11T01:01:00',
  DataAtestado: '2021-05-10T00:00:00',
  Texto: 'deverá permanecer em repouso a partir de hoje por',
  Observacao: 'Uma observação bem interessante',
  Periodo: '10',
  TipoPeriodo: 'relativo',
  TextoCompleto:
    'Esteve sob meus cuidados profissionais no período de <strong>00:00hrs</strong> às <strong>01:01hrs</strong> do dia <strong>10/05/2021</strong>, e deverá permanecer em repouso relativo a partir de hoje por 10 dias.',
  ConsentimentoCID: true,
  CID10Estruturado: [
    {
      Codigo: 'A00.0',
      idCID10: 1,
      Descricao: 'Cólera devida a Vibrio cholerae 01, biótipo cholerae',
    },
  ],
  CampoLivre: false,
  DeclaracaoComparecimento: false,
  TextoConsentimento: '',
  idPrescricao: 429041,
  Tipo: MEDICAL_CERTIFICATE_DOCUMENT_TYPE.MEDICAL_CERTIFICATE,
  AdicionadoPorIA: false,
});

export const DEFAULT_SMR_FORM = (): SMRForm => {
  return {
    pacienteLme: {
      idPrescricaoPacienteLme: 152,
      idPrescricao: 6596209,
      TipoDocumento: 'CPF',
      Documento: '319.121.900-52',
      Email: 'paciente@gmail.com',
      Telefone: '34912345678',
      Nome: 'Nome do Paciente com o Nome Completo',
      NomeMae: 'Nome da Mae do Paciente com o Nome Completo',
      NomeResponsavel: 'Nome responsavel pelo Paciente com o Nome Completo',
      Peso: 100,
      Altura: 200,
      Etnia: 'Condição étnico-racial declarada pelo paciente ou responsável',
      EtniaIndigena: '',
      Incapaz: false,
      PreenchimentoManual: false,
    },
    medicoLme: {
      idPrescricaoMedicoLme: 156,
      idPrescricao: 6596209,
      cns: '966159773610003',
      nome: 'Médico Teste alter',
    },
    estabelecimentoLme: {
      idPrescricaoEstabelecimentoLme: 164,
      idPrescricao: 6596209,
      cnes: '111',
      nome: 'Santo Médico Teste',
    },
    prescricaoCidLme: [
      {
        idPrescricaoCidLme: 318,
        idPrescricao: 6596209,
        anamnese: 'anamnese simples',
        cid: { id: 4548, descricao: 'Doença reumatóide do pulmão', subCategoria: 'M05.1' },
        descricaoTratamento: null,
        tratamentoAnterior: false,
        medicamentosLme: [
          {
            paranaSemDor: false,
            idPrescricaoLmeIcd: 318,
            idPrescricaoMedicamentoLme: 337,
            idPrescricaoMedicamento: 337,
            label: 'ABATACEPTE 125MG/ML',
            MedicamentosUnidadeLme: [
              { idPrescricaoMedicamentoUnidadeLme: 2191, idPrescricaoMedicamentoLme: 337, mes: 1, unidade: 1 },
              { idPrescricaoMedicamentoUnidadeLme: 2192, idPrescricaoMedicamentoLme: 337, mes: 2, unidade: 2 },
              { idPrescricaoMedicamentoUnidadeLme: 2193, idPrescricaoMedicamentoLme: 337, mes: 3, unidade: 3 },
              { idPrescricaoMedicamentoUnidadeLme: 2194, idPrescricaoMedicamentoLme: 337, mes: 4, unidade: 4 },
              { idPrescricaoMedicamentoUnidadeLme: 2195, idPrescricaoMedicamentoLme: 337, mes: 5, unidade: 5 },
              { idPrescricaoMedicamentoUnidadeLme: 2196, idPrescricaoMedicamentoLme: 337, mes: 6, unidade: 6 },
            ],
          },
        ],
        termosResponsabilidadeDisponiveis: [],
        termosResponsabilidadeSelecionados: [],
      },
      {
        idPrescricaoCidLme: 323,
        idPrescricao: 6596209,
        anamnese: 'anamnese simples',
        cid: { id: 2939, descricao: 'Glaucoma primário de ângulo aberto', subCategoria: 'H40.1' },
        descricaoTratamento: null,
        tratamentoAnterior: false,
        medicamentosLme: [
          {
            idPrescricaoLmeIcd: 323,
            idPrescricaoMedicamentoLme: 342,
            idPrescricaoMedicamento: 342,
            label: 'ACETAZOLAMIDA 250MG',
            paranaSemDor: false,
            MedicamentosUnidadeLme: [
              { idPrescricaoMedicamentoUnidadeLme: 2197, idPrescricaoMedicamentoLme: 342, mes: 1, unidade: 7 },
              { idPrescricaoMedicamentoUnidadeLme: 2198, idPrescricaoMedicamentoLme: 342, mes: 2, unidade: 8 },
              { idPrescricaoMedicamentoUnidadeLme: 2199, idPrescricaoMedicamentoLme: 342, mes: 3, unidade: 9 },
              { idPrescricaoMedicamentoUnidadeLme: 2200, idPrescricaoMedicamentoLme: 342, mes: 4, unidade: 10 },
              { idPrescricaoMedicamentoUnidadeLme: 2201, idPrescricaoMedicamentoLme: 342, mes: 5, unidade: 11 },
              { idPrescricaoMedicamentoUnidadeLme: 2202, idPrescricaoMedicamentoLme: 342, mes: 6, unidade: 12 },
            ],
          },
        ],
        termosResponsabilidadeDisponiveis: [],
        termosResponsabilidadeSelecionados: [],
      },
      {
        idPrescricaoCidLme: 324,
        idPrescricao: 6596209,
        anamnese: 'anamnese simples',
        cid: { id: 1971, descricao: 'Hipercolesterolemia pura', subCategoria: 'E78.0' },
        descricaoTratamento: null,
        tratamentoAnterior: false,
        medicamentosLme: [
          {
            idPrescricaoLmeIcd: 324,
            idPrescricaoMedicamentoLme: 343,
            idPrescricaoMedicamento: 343,
            label: 'ATORVASTATINA 10MG',
            paranaSemDor: false,
            MedicamentosUnidadeLme: [
              { idPrescricaoMedicamentoUnidadeLme: 2203, idPrescricaoMedicamentoLme: 343, mes: 1, unidade: 20 },
              { idPrescricaoMedicamentoUnidadeLme: 2204, idPrescricaoMedicamentoLme: 343, mes: 2, unidade: 21 },
              { idPrescricaoMedicamentoUnidadeLme: 2205, idPrescricaoMedicamentoLme: 343, mes: 3, unidade: 22 },
              { idPrescricaoMedicamentoUnidadeLme: 2206, idPrescricaoMedicamentoLme: 343, mes: 4, unidade: 23 },
              { idPrescricaoMedicamentoUnidadeLme: 2207, idPrescricaoMedicamentoLme: 343, mes: 5, unidade: 24 },
              { idPrescricaoMedicamentoUnidadeLme: 2208, idPrescricaoMedicamentoLme: 343, mes: 6, unidade: 25 },
            ],
          },
        ],
        termosResponsabilidadeDisponiveis: [],
        termosResponsabilidadeSelecionados: [],
      },
    ],
  };
};

export const DEFAULT_PARANA_SEM_DOR_FORM = (): SMRForm => {
  return {
    pacienteLme: {
      idPrescricaoPacienteLme: 152,
      idPrescricao: 6596209,
      TipoDocumento: 'CPF',
      Documento: '319.121.900-52',
      Email: 'paciente@gmail.com',
      Telefone: '34912345678',
      Nome: 'Nome do Paciente com o Nome Completo',
      NomeMae: 'Nome da Mae do Paciente com o Nome Completo',
      NomeResponsavel: 'Nome responsavel pelo Paciente com o Nome Completo',
      Peso: 100,
      Altura: 200,
      Etnia: 'Condição étnico-racial declarada pelo paciente ou responsável',
      EtniaIndigena: '',
      Incapaz: false,
      PreenchimentoManual: false,
    },
    medicoLme: {
      idPrescricaoMedicoLme: 156,
      idPrescricao: 6596209,
      cns: '966159773610003',
      nome: 'Médico Teste alter',
    },
    estabelecimentoLme: {
      idPrescricaoEstabelecimentoLme: 164,
      idPrescricao: 6596209,
      cnes: '111',
      nome: 'Santo Médico Teste',
    },
    prescricaoCidLme: [
      {
        idPrescricaoCidLme: 318,
        idPrescricao: 6596209,
        anamnese: 'anamnese simples',
        cid: { id: 4548, descricao: 'Doença reumatóide do pulmão', subCategoria: 'M05.1' },
        descricaoTratamento: null,
        tratamentoAnterior: false,
        medicamentosLme: [
          {
            paranaSemDor: true,
            idPrescricaoLmeIcd: 318,
            idPrescricaoMedicamentoLme: 337,
            idPrescricaoMedicamento: 337,
            label: 'ABATACEPTE 125MG/ML',
            MedicamentosUnidadeLme: [
              { idPrescricaoMedicamentoUnidadeLme: 2191, idPrescricaoMedicamentoLme: 337, mes: 1, unidade: 1 },
              { idPrescricaoMedicamentoUnidadeLme: 2192, idPrescricaoMedicamentoLme: 337, mes: 2, unidade: 2 },
              { idPrescricaoMedicamentoUnidadeLme: 2193, idPrescricaoMedicamentoLme: 337, mes: 3, unidade: 3 },
              { idPrescricaoMedicamentoUnidadeLme: 2194, idPrescricaoMedicamentoLme: 337, mes: 4, unidade: 4 },
              { idPrescricaoMedicamentoUnidadeLme: 2195, idPrescricaoMedicamentoLme: 337, mes: 5, unidade: 5 },
              { idPrescricaoMedicamentoUnidadeLme: 2196, idPrescricaoMedicamentoLme: 337, mes: 6, unidade: 6 },
            ],
          },
        ],
        termosResponsabilidadeDisponiveis: [
          {
            id: 399,
            name: 'Artrite Reumatoide',
            url: '',
          },
        ],
        termosResponsabilidadeSelecionados: [],
      },
    ],
  };
};

export const DEFAULT_BENEFIT = (): PSPBenefit => ({
  Tipo: BENEFIT_TYPE.PARCEIRO,
  Nome: 'nexodata',
  Logo: 'https://media-exp1.licdn.com/dms/image/C4D0BAQGz5FmVK3l4_Q/company-logo_200_200/0/1594038371115?e=2159024400&v=beta&t=kiYerzgJljg3DoXoF2QW2Hrj-jr0s5dzsDMPlTPY1MY',
  CorFundo: '#D9FBF9',
  Descricao: 'teste',
  CorTexto: '#00778F',
  PermitirFiltroNaBusca: true,
  DescontosLabel: 'O programa nexodata fornece desconto na compra do medicamento apenas em embalagens com 30 unidades',
  Descontos: [
    {
      Unidades: '30',
    },
  ],
});

export { MOCK_PSP_BENEFIT_SEARCH } from '../../../contants/mockPspBenefitForSearch';

export const DEFAULT_PRESCRIBER_CONFIGURATIONS = (): PrescriberConfigurations => ({
  Conselho: 'CRM',
  Documento: '11400040698',
  idMedico: 21681,
  Nome: 'Médico Teste alter',
  UF: '',
  Numero: 'NX12348',
  UFConselho: 'SP',
  Especialidades: ['GERIATRIA'],
  Configuracoes: {
    dialogs: {
      controlledPrescriptionSigned: {
        value: false,
        lastUpdated: new Date(),
      },
    },
    firstAccess: false,
    openRate: {
      value: '0',
      range: '0',
    },
    openPatientApp: false,
  },
  ExibirDataPdf: true,
  UltimaAssinatura: null,
});

export const DEFAULT_MEDICINES_WITH_SPECIAL_CONTROL_OR_ANTIMICROBIAL = (): Medicine[] => [
  {
    idPrescricaoMedicamento: 11727611,
    Posologia: 'Tomar 1 comprimido via oral',
    Quantidade: 1,
    Embalagem: 3,
    Embalagens: ['500', '3', '300'],
    UsoContinuo: false,
    PermitirTroca: 0,
    FarmaciaPopular: false,
    AtivoAnvisa: true,
    ViaAdministracao: 'ORAL',
    ImpressaoDuasVias: true,
    Dispensado: false,
    QuantidadeDispensada: 0,
    ListaEANS: ['7896862910709'],
    DetalhesDispensa: [],
    IdMedicamento: 3891,
    Nome: 'AZITROMED',
    Concentracao: '500',
    LaboratorioPreferencia: 0,
    Unidade: 'MG',
    Farmacos: ['AZITROMICINA'],
    PrincipiosAtivos: [
      {
        Nome: 'AZITROMICINA',
        CAS: '83905-01-5',
      },
    ],
    Grupo: 'GRUPO_TESTE',
    TipoMedicamento: 'SIMILAR INTERCAMBIAVEL',
    TipoMedicamentoComAcentuacao: 'SIMILAR INTERCAMBIÁVEL',
    FormaFarmaceutica: 'Comprimido Revestido',
    FormaFarmaceuticaComAcentuacao: 'Comprimido Revestido',
    UsoInterno: true,
    ProdutoCorrelato: false,
    Antimicrobiano: true,
    idTipoAntimicrobiano: 1,
    AntimicrobianoDescricao: 'Antimicrobiano controlado',
    Desconto: 0,
    LME: false,
    MaiorPreco: 19.73,
    MenorPreco: 19.73,
    PodeDispensaEletronica: true,
    idPortaria344: 0,
    IdViaAdministracao: 0,
    CodigoATC: 'J01FA10',
    ControleEspecial: false,
    MIP: false,
    TemBeneficio: false,
    Label: 'AZITROMED 500 MG - Comprimido revestido',
    LabelFarmaco: '',
    Beneficios: [],
    PossuiRemume: false,
    PossuiRename: false,
    QuantidadeUnidadeFormatada: '1 caixa com 3 unidades',
    Ordem: 1,
    EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
    EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
    ParanaSemDor: false,
  },
  {
    idPrescricaoMedicamento: 11727627,
    Posologia: 'Tomar 1 comprimido via oral',
    Quantidade: 1,
    Embalagens: ['30'],
    UsoContinuo: false,
    PermitirTroca: 0,
    FarmaciaPopular: false,
    AtivoAnvisa: true,
    ViaAdministracao: 'ORAL',
    ImpressaoDuasVias: true,
    Dispensado: false,
    QuantidadeDispensada: 0,
    ListaEANS: ['7891058019914'],
    DetalhesDispensa: [],
    IdMedicamento: 29239,
    Nome: 'STILNOX',
    Concentracao: '6,25',
    Unidade: 'MG',
    LaboratorioPreferencia: 0,
    Farmacos: ['HEMITARTARATO DE ZOLPIDEM'],
    PrincipiosAtivos: [
      {
        Nome: 'HEMITARTARATO DE ZOLPIDEM',
        CAS: '99294-93-6',
      },
    ],
    Grupo: 'GRUPO_TESTE',
    TipoMedicamento: 'NOVO',
    TipoMedicamentoComAcentuacao: 'NOVO',
    FormaFarmaceutica: 'Comprimido De Acao Prolongada',
    FormaFarmaceuticaComAcentuacao: 'Comprimido De Ação Prolongada',
    UsoInterno: true,
    ProdutoCorrelato: false,
    Antimicrobiano: false,
    idTipoAntimicrobiano: 3,
    AntimicrobianoDescricao: 'Não é antimicrobiano',
    Desconto: 0,
    LME: false,
    MaiorPreco: 53.56,
    MenorPreco: 53.56,
    PodeDispensaEletronica: true,
    Portaria344: 'LISTA B1 - adendo - Receita de Controle Especial em duas vias',
    idPortaria344: 14,
    IdViaAdministracao: 0,
    CodigoATC: 'N05CF02',
    ControleEspecial: true,
    MIP: false,
    TemBeneficio: false,
    Label: 'STILNOX 6,25 MG - Comprimido de ação prolongada',
    LabelFarmaco: '',
    Beneficios: [],
    PossuiRemume: false,
    PossuiRename: false,
    QuantidadeUnidadeFormatada: '',
    Ordem: 2,
    EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
    EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
    ParanaSemDor: false,
  },
];
export const DEFAULT_HISTORY = (): PrescriptionHistory => ({
  Medico: {
    idMedico: 1,
  },
  Prescricoes: [
    {
      idPrescricao: 6617348,
      Referencia: '1824265209218',
      DataCriacao: '2021-10-04T11:36:44.000Z',
      CodigoValidacao: 'NX7KV15',
      UrlQrCode: 'https://s3-sa-east-1.amazonaws.com/nxd-prescricao-codigo/c68839b7-e9ed-43a7-af18-b5855aea0e61.png',
      habilitarBotaoMais: true,
      Status: {
        idPrescricaoStatus: 2,
        Descricao: 'Emitida',
      },
      Medicamentos: [
        {
          idPrescricaoMedicamento: 11727388,
          idMedicamento: 29350,
          Comentario: '',
          Posologia: 'Injetar via intravenosa',
          UsoContinuo: false,
          Quantidade: 1,
          QuantidadeEmbalagens: '1',
          medicamentoLme: null,
          Medicamento: {
            idMedicamento: 29350,
            idPortaria344: 0,
            idTipoMedicamento: 9,
            ControleEspecial: true,
            Nome: 'ORENCIA',
            Concentracao: '125',
            Unidade: 'MG/ML',
          },
          Ordem: null,
        },
        {
          idPrescricaoMedicamento: 11727388,
          idMedicamento: 123,
          Comentario: '',
          Posologia: 'Injetar via intravenosa',
          UsoContinuo: false,
          Quantidade: 1,
          QuantidadeEmbalagens: '1',
          medicamentoLme: {
            cid: 'M05.1',
            unidades: [
              {
                unidade: 1,
                mes: 1,
              },
            ],
          },
          Medicamento: {
            idMedicamento: 29350,
            idPortaria344: 0,
            idTipoMedicamento: 9,
            ControleEspecial: true,
            Nome: 'ORENCIA LME',
            Concentracao: '125',
            Unidade: 'MG/ML',
          },
          Ordem: null,
        },
      ],
      MedicamentosManuais: [
        {
          QuantidadeDispensada: 0,
          Posologia: 'Tomar 2 vezes ao dia de 6 em 6 horas',
          Nome: 'Medicamento que não existe na base',
          Comentario: '',
          idMedicamentoManual: 321,
          Label: 'Medicamento que não existe na base',
          DetalhesDispensa: [],
          idPrescricaoMedicamentoManual: 123,
          Dispensado: false,
          Quantidade: 1,
          Embalagem: '12',
          UsoContinuo: false,
          UsoInterno: false,
          Ordem: null,
        },
      ],
      Formulas: [DEFAULT_FORMULA()],
      Exames: [DEFAULT_EXAM()],
      Atestados: [DEFAULT_MEDICAL_CERTIFICATE()],
      Encaminhamentos: [DEFAULT_MEDICAL_REFERRAL()],
      Medico: {
        idMedico: 1,
      },
      PodeCancelar: true,
      Relatorios: [DEFAULT_MEDICAL_REPORT()],
      cancelados: [],
    },
    {
      idPrescricao: 6617348,
      Referencia: '1824265209218',
      DataCriacao: '2018-09-03T11:36:44.000Z',
      CodigoValidacao: 'NXK1NSW',
      UrlQrCode: 'https://s3-sa-east-1.amazonaws.com/nxd-prescricao-codigo/c68839b7-e9ed-43a7-af18-b5855aea0e61.png',
      habilitarBotaoMais: true,
      Status: {
        idPrescricaoStatus: 2,
        Descricao: 'Emitida',
      },
      Medicamentos: [
        {
          idPrescricaoMedicamento: 11727388,
          idMedicamento: 29350,
          Comentario: '',
          Posologia: 'Injetar via intravenosa',
          UsoContinuo: false,
          Quantidade: 1,
          QuantidadeEmbalagens: '1',
          medicamentoLme: null,
          Medicamento: {
            idMedicamento: 29350,
            idPortaria344: 0,
            idTipoMedicamento: 9,
            ControleEspecial: true,
            Nome: 'ORENCIA',
            Concentracao: '125',
            Unidade: 'MG/ML',
          },
          Ordem: null,
        },
      ],
      MedicamentosManuais: [],
      Formulas: [DEFAULT_FORMULA()],
      Exames: [DEFAULT_EXAM()],
      Atestados: [DEFAULT_MEDICAL_CERTIFICATE()],
      Encaminhamentos: [DEFAULT_MEDICAL_REFERRAL()],
      Medico: {
        idMedico: 2,
      },
      PodeCancelar: true,
      Relatorios: [],
      cancelados: [],
    },
  ],
  PossuiProximaPagina: true,
});

export const DEFAULT_MINOR_SEVERITY = (): SeverityDetails => ({
  idPrimeiroMedicamento: null,
  idSegundomedicamento: null,
  severidade: 'MINOR',
  tipo: 'LAB',
  textoAviso:
    'NONSTEROIDAL ANTIINFLAMMATORY AGENTS may result in falsely positive fecal hemoccult tests due to NSAID-induced gastrointestinal bleeding.',
});

export const DEFAULT_CONTRAINDICATED_SEVERITY = (): SeverityDetails => ({
  idPrimeiroMedicamento: null,
  idSegundomedicamento: null,
  severidade: 'CONTRAINDICATED',
  tipo: 'INGREDIENT_DUPLICATION',
  textoAviso:
    'An ingredient duplication has occurred.  The ingredient DIPYRONE has been duplicated in the following products: DIPYRONE and DIPYRONE.',
});

export const DEFAULT_MODERATE_SEVERITY = (): SeverityDetails => ({
  idPrimeiroMedicamento: null,
  idSegundomedicamento: null,
  severidade: 'MODERATE',
  tipo: 'ETHANOL',
  textoAviso: 'Concurrent use of ETHANOL and ASPIRIN may result in increased risk of gastrointestinal bleeding.',
});

export const DEFAULT_MAJOR_SEVERITY = (): SeverityDetails => ({
  idPrimeiroMedicamento: null,
  idSegundomedicamento: null,
  severidade: 'MAJOR',
  tipo: 'ETHANOL',
  textoAviso: 'Concurrent use of ZOLPIDEM and ETHANOL may result in increased sedation.',
});

export const DEFAULT_SEVERITY_BETWEEN_MEDICINES = (): SeverityDetails => ({
  idPrimeiroMedicamento: 11103,
  idSegundomedicamento: 30818,
  severidade: 'MAJOR',
  textoAviso:
    'Concurrent use of NSAID and SEROTONIN NOREPINEPHRINE REUPTAKE INHIBITORS may result in an increased risk of bleeding.',
  tipo: 'DRUG',
});

export const DEFAULT_DOCUMENTS_PREVIEW = (): Documents => ({
  documents: [
    {
      type: 'MEDICINE',
      category: 'MEDICINE',
      pdfBase64: '',
      html: [''],
    },
    {
      type: 'MEDICAL_STATEMENT',
      category: 'MEDICAL_STATEMENT',
      pdfBase64: '',
      html: [''],
    },
    {
      type: 'EXAM',
      category: 'EXAM',
      pdfBase64: '',
      html: [''],
    },
    {
      type: 'SMR',
      category: 'SMR',
      pdfBase64: '',
      html: [''],
    },
    {
      type: 'REFERRAL',
      category: 'REFERRAL',
      pdfBase64: '',
      html: [''],
    },
  ],
});

export const ALL_CERTIFICATES = (): OwnedCertificate[] => [
  {
    status: 'S',
    name: CERTIFICATES.SAFEWEB,
    certifierStatus: CERTIFIER_STATUS.ACTIVE,
    description: null,
  },
  {
    status: 'S',
    name: CERTIFICATES.SOLUTI,
    certifierStatus: CERTIFIER_STATUS.ACTIVE,
    description: null,
  },
  {
    status: 'S',
    name: CERTIFICATES.VALID,
    certifierStatus: CERTIFIER_STATUS.ACTIVE,
    description: null,
  },
  {
    status: 'S',
    name: CERTIFICATES.EVAL_CONTEXT,
    certifierStatus: CERTIFIER_STATUS.ACTIVE,
    description: null,
  },
];

export const DEFAULT_SPECIALTIES = (): Specialty[] => [
  {
    Nome: 'CLÍNICA MÉDICA',
    IdEspecialidade: 2,
    NomeProfissional: 'Clínico Geral',
  },
  {
    Nome: 'PATOLOGIA CLÍNICA',
    IdEspecialidade: 22,
    NomeProfissional: 'Patologista',
  },
  {
    Nome: 'GASTROCLÍNICO',
    IdEspecialidade: 103,
    NomeProfissional: 'Gastroclínico',
  },
  {
    Nome: 'DENTISTA - CLINICO GERAL',
    IdEspecialidade: 108,
    NomeProfissional: 'Dentista',
  },
  {
    Nome: 'ENDOCRINOLOGIA',
    IdEspecialidade: 3,
    NomeProfissional: 'Endócrino',
  },
];

export const DEFAULT_MEDICAL_REFERRAL = (): MedicalReferral => ({
  idEncaminhamentoPrescricao: 1,
  DataEncaminhamento: new Date(),
  Motivo: 'Motivo',
  HistoriaClinica: 'Historia clinica',
  Conduta: 'conduta',
  Especialidade: {
    Nome: 'CLÍNICA MÉDICA',
    IdEspecialidade: 2,
    NomeProfissional: 'Clínico Geral',
  },
  CID10: {
    Descricao: 'Cólera devida a Vibrio cholerae 01, biótipo cholerae',
    IdSubCategoria: 1,
    SubCategoria: 'A00.0',
  },
  DescricaoEspecialidade: '',
  tipoParecer: '',
  Origem: OriginEnum.MEDFLOW,
  AdicionadoPorIA: false,
});

export const DEFAULT_MIP_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11736110,
  Posologia: 'Tomar 1 gota via oral',
  Quantidade: 1,
  Embalagem: 1,
  Embalagens: [
    '1',
    '100',
    '200',
    '200',
    '200',
    '200',
    '1',
    '1',
    '300',
    '1',
    '50',
    '50',
    '50',
    '100',
    '1',
    '100',
    '100',
    '1',
    '100',
    '200',
    '100',
    '200',
  ],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: [
    '7898166041080',
    '7898166041097',
    '7898166040861',
    '7898166040892',
    '7898166041073',
    '7898166041103',
    '7895005800402',
    '7893314210219',
    '7896212705538',
    '7897322705552',
    '7896862918279',
  ],
  DetalhesDispensa: [],
  IdMedicamento: 11103,
  Nome: 'DIPIRONA',
  Concentracao: '500',
  Unidade: 'MG/ML',
  Farmacos: ['DIPIRONA'],
  PrincipiosAtivos: [
    {
      Nome: 'DIPIRONA',
      CAS: '68-89-3',
    },
  ],
  Grupo: 'GRUPO_TESTE',
  TipoMedicamento: 'GENERICO',
  TipoMedicamentoComAcentuacao: 'GENÉRICO',
  FormaFarmaceutica: 'Solucao Oral (Gotas)',
  FormaFarmaceuticaComAcentuacao: 'Solução Oral (Gotas)',
  UsoInterno: true,
  ProdutoCorrelato: false,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  LME: false,
  MaiorPreco: 136.24,
  MenorPreco: 0,
  PodeDispensaEletronica: true,
  idPortaria344: 0,
  IdViaAdministracao: 0,
  CodigoATC: 'N02BB02',
  ControleEspecial: false,
  MIP: true,
  TemBeneficio: false,
  Label: 'DIPIRONA 500 MG/ML - Solução oral (gotas)',
  LabelFarmaco: '',
  Beneficios: [],
  LaboratorioPreferencia: 1,
  QuantidadeUnidadeFormatada: '1 caixa com 1 unidade',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_SPECIAL_CONTROL_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11736112,
  Posologia: 'Tomar 1 comprimido via oral',
  Quantidade: 1,
  Embalagens: ['14', '30'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: true,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7898943707994', '7899420506369'],
  DetalhesDispensa: [],
  IdMedicamento: 565,
  Nome: 'ATIP',
  Concentracao: '25',
  Unidade: 'MG',
  Farmacos: ['HEMIFUMARATO DE QUETIAPINA'],
  PrincipiosAtivos: [
    {
      Nome: 'HEMIFUMARATO DE QUETIAPINA',
      CAS: '111974-72-2',
    },
  ],
  Grupo: 'GRUPO_TESTE',
  TipoMedicamento: 'SIMILAR INTERCAMBIAVEL',
  TipoMedicamentoComAcentuacao: 'SIMILAR INTERCAMBIÁVEL',
  FormaFarmaceutica: 'Comprimido Revestido',
  FormaFarmaceuticaComAcentuacao: 'Comprimido Revestido',
  UsoInterno: true,
  ProdutoCorrelato: false,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  LME: true,
  MaiorPreco: 98.08,
  MenorPreco: 47.53,
  PodeDispensaEletronica: true,
  Portaria344: 'LISTA C1 - Receita de Controle Especial em duas vias',
  idPortaria344: 6,
  IdViaAdministracao: 0,
  CodigoATC: 'N05AH04',
  ControleEspecial: true,
  MIP: false,
  TemBeneficio: false,
  Label: 'ATIP 25 MG - Comprimido revestido',
  LabelFarmaco: '',
  Beneficios: [],
  LaboratorioPreferencia: 1,
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_SIMPLE_IN_TWO_RECEIPT_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11736116,
  Posologia: 'Tomar 1 comprimido via oral',
  Quantidade: 1,
  Embalagens: ['150', '30', '2', '40', '80', '300', '1', '1', '150', '50', '1', '1', '1', '1', '70'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: true,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: [
    '7899547502077',
    '7898148300563',
    '7898148300518',
    '7898148300525',
    '7898148300549',
    '7896004715278',
    '7898148300556',
    '7898148300532',
    '7898148306787',
    '7899547502039',
    '7899547502107',
  ],
  DetalhesDispensa: [],
  IdMedicamento: 3920,
  Nome: 'AZITROMICINA',
  Concentracao: '1',
  Unidade: 'G',
  Farmacos: ['AZITROMICINA DI-HIDRATADA'],
  PrincipiosAtivos: [
    {
      Nome: 'AZITROMICINA DI-HIDRATADA',
      CAS: '117772-70-0',
    },
  ],
  TipoMedicamento: 'GENERICO',
  TipoMedicamentoComAcentuacao: 'GENÉRICO',
  FormaFarmaceutica: 'Comprimido Revestido',
  FormaFarmaceuticaComAcentuacao: 'Comprimido Revestido',
  UsoInterno: true,
  ProdutoCorrelato: false,
  Antimicrobiano: true,
  idTipoAntimicrobiano: 1,
  AntimicrobianoDescricao: 'Antimicrobiano controlado',
  Desconto: 0,
  LME: false,
  MaiorPreco: 1109.26,
  MenorPreco: 18.3,
  PodeDispensaEletronica: true,
  idPortaria344: 0,
  IdViaAdministracao: 0,
  CodigoATC: 'J01FA10',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'AZITROMICINA 1 G - Comprimido revestido',
  LabelFarmaco: '',
  Beneficios: [],
  LaboratorioPreferencia: 1,
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_CONTROLLED_ANTIMICROBIAL_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11736119,
  Posologia: 'Tomar via oral',
  Quantidade: 1,
  Embalagens: ['1', '1'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: true,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7896226500379'],
  DetalhesDispensa: [],
  IdMedicamento: 4080,
  Nome: 'BACTRIM F',
  Concentracao: '80 + 16',
  Unidade: 'MG/ML',
  Farmacos: ['SULFAMETOXAZOL', 'TRIMETOPRIMA'],
  PrincipiosAtivos: [
    {
      Nome: 'SULFAMETOXAZOL',
      CAS: '723-46-6',
    },
    {
      Nome: 'TRIMETOPRIMA',
      CAS: '738-70-5',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Suspensao Oral',
  FormaFarmaceuticaComAcentuacao: 'Suspensão Oral',
  UsoInterno: true,
  ProdutoCorrelato: false,
  Antimicrobiano: true,
  idTipoAntimicrobiano: 1,
  AntimicrobianoDescricao: 'Antimicrobiano controlado',
  Desconto: 0,
  LME: false,
  MaiorPreco: 19.84,
  MenorPreco: 19.84,
  PodeDispensaEletronica: true,
  idPortaria344: 0,
  IdViaAdministracao: 0,
  CodigoATC: 'J01EE01',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'BACTRIM F 80 + 16 MG/ML - Suspensão oral',
  LabelFarmaco: '',
  Beneficios: [],
  LaboratorioPreferencia: 1,
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_NOTIFICATION_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11736125,
  Posologia: 'Colocar 1 comprimido embaixo da língua',
  Quantidade: 1,
  Embalagens: ['30'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7896226504742'],
  DetalhesDispensa: [],
  IdMedicamento: 23625,
  Nome: 'RIVOTRIL',
  Concentracao: '0,25',
  Unidade: 'MG',
  Farmacos: ['CLONAZEPAM'],
  PrincipiosAtivos: [
    {
      Nome: 'CLONAZEPAM',
      CAS: '1622-61-3',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Comprimido Sublingual',
  FormaFarmaceuticaComAcentuacao: 'Comprimido Sublingual',
  UsoInterno: true,
  ProdutoCorrelato: false,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  LME: false,
  MaiorPreco: 6.57,
  MenorPreco: 6.57,
  PodeDispensaEletronica: false,
  Portaria344: 'LISTA B1 - Notificação de Receita B',
  idPortaria344: 4,
  IdViaAdministracao: 0,
  CodigoATC: 'N03AE01',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'RIVOTRIL 0,25 MG - Comprimido sublingual',
  LabelFarmaco: '',
  Beneficios: [],
  LaboratorioPreferencia: 1,
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_BLACK_STRIPE_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11731358,
  Posologia: 'Colocar 1 comprimido embaixo da língua',
  Quantidade: 1,
  Embalagens: ['30'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7896226504742'],
  DetalhesDispensa: [],
  IdMedicamento: 23625,
  Nome: 'RIVOTRIL',
  Concentracao: '0,25',
  Unidade: 'MG',
  Farmacos: ['CLONAZEPAM'],
  PrincipiosAtivos: [
    {
      Nome: 'CLONAZEPAM',
      CAS: '1622-61-3',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Comprimido Sublingual',
  FormaFarmaceuticaComAcentuacao: 'Comprimido Sublingual',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  MaiorPreco: 6.57,
  MenorPreco: 6.57,
  PodeDispensaEletronica: false,
  Portaria344: 'LISTA B1 - Notificação de Receita B',
  idPortaria344: 4,
  IdViaAdministracao: 0,
  CodigoATC: 'N03AE01',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'RIVOTRIL 0,25 MG - Comprimido sublingual',
  LaboratorioPreferencia: 1,
  LME: false,
  ProdutoCorrelato: false,
  LabelFarmaco: '',
  Beneficios: [],
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_BLUE_STRIPE_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11731357,
  Posologia: 'Tomar 1 comprimido via oral',
  Quantidade: 1,
  Embalagens: ['10', '100', '200', '10', '100'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: true,
  QuantidadeDispensada: 1,
  ListaEANS: ['7891058001155', '7891058011222', '7891058001377', '7896070607736', '7896070607743'],
  DetalhesDispensa: [
    {
      Medicamento: 'EAN NÃO ENCONTRADO.',
      Apresentacao: '',
      QuantidadeDispensada: 1,
      DataVenda: '2021-10-07T00:00:00',
      PermiteCancelar: false,
      CodigoCompraReferencia: '',
    },
  ],
  IdMedicamento: 20227,
  Nome: 'NOVALGINA',
  Concentracao: '1',
  Unidade: 'G',
  Farmacos: ['DIPIRONA'],
  PrincipiosAtivos: [
    {
      Nome: 'DIPIRONA',
      CAS: '68-89-3',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Comprimido',
  FormaFarmaceuticaComAcentuacao: 'Comprimido',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  MaiorPreco: 372.43,
  MenorPreco: 18.54,
  PodeDispensaEletronica: true,
  idPortaria344: 0,
  IdViaAdministracao: 0,
  CodigoATC: 'N02BB02',
  ControleEspecial: false,
  MIP: true,
  TemBeneficio: false,
  Label: 'NOVALGINA 1 G - Comprimido',
  LaboratorioPreferencia: 1,
  LME: false,
  ProdutoCorrelato: false,
  LabelFarmaco: '',
  Beneficios: [],
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_RED_STRIPE_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11731360,
  Posologia: 'Injetar via intravenosa',
  Quantidade: 1,
  Embalagens: ['1', '1', '4', '4', '1', '4'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'INTRAVENOSA',
  ImpressaoDuasVias: false,
  Dispensado: true,
  QuantidadeDispensada: 1,
  ListaEANS: ['7896016807442', '7896016807459', '7896016807466', '7896016807473', '7896016808180', '7896016808197'],
  DetalhesDispensa: [
    {
      Medicamento: 'EAN NÃO ENCONTRADO.',
      Apresentacao: '',
      QuantidadeDispensada: 1,
      DataVenda: '2021-10-07T00:00:00',
      PermiteCancelar: false,
      CodigoCompraReferencia: '',
    },
  ],
  IdMedicamento: 29350,
  Nome: 'ORENCIA',
  Concentracao: '125',
  Unidade: 'MG/ML',
  Farmacos: ['ABATACEPTE'],
  PrincipiosAtivos: [
    {
      Nome: 'ABATACEPTE',
      CAS: '332348-12-6',
    },
  ],
  TipoMedicamento: 'BIOLOGICO',
  TipoMedicamentoComAcentuacao: 'BIOLÓGICO',
  FormaFarmaceutica: 'Solucao Injetavel',
  FormaFarmaceuticaComAcentuacao: 'Solução Injetável',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  MaiorPreco: 7254.64,
  MenorPreco: 1813.62,
  PodeDispensaEletronica: true,
  idPortaria344: 0,
  IdViaAdministracao: 0,
  CodigoATC: 'L04AA24',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'ORENCIA 125 MG/ML - Solução injetável',
  LaboratorioPreferencia: 1,
  LME: false,
  ProdutoCorrelato: false,
  LabelFarmaco: '',
  Beneficios: [],
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_A_TAG_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11731459,
  Posologia: 'Injetar via intravenosa/peridural',
  Quantidade: 1,
  Embalagens: ['50'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'INTRAVENOSA/PERIDURAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: [],
  DetalhesDispensa: [],
  IdMedicamento: 10916,
  Nome: 'DIMORF',
  Concentracao: '0,1',
  Unidade: 'MG/ML',
  Farmacos: ['MORFINA'],
  PrincipiosAtivos: [
    {
      Nome: 'MORFINA',
      CAS: '57-27-2',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Solucao Injetavel',
  FormaFarmaceuticaComAcentuacao: 'Solução Injetável',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  MaiorPreco: 0,
  MenorPreco: 0,
  PodeDispensaEletronica: false,
  Portaria344: 'LISTA A1 - Notificação de Receita A',
  idPortaria344: 1,
  IdViaAdministracao: 0,
  CodigoATC: 'N02AA01',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'DIMORF 0,1 MG/ML - Solução injetável',
  LaboratorioPreferencia: 1,
  LME: false,
  ProdutoCorrelato: false,
  LabelFarmaco: '',
  Beneficios: [],
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_B2_TAG_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11731460,
  Posologia: 'Tomar 1 cápsula via oral',
  Quantidade: 1,
  Embalagens: ['30', '10', '30'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7891317450700', '7891317481650'],
  DetalhesDispensa: [],
  IdMedicamento: 24265,
  Nome: 'SIBUS',
  Concentracao: '10',
  Unidade: 'MG',
  Farmacos: ['CLORIDRATO DE SIBUTRAMINA'],
  PrincipiosAtivos: [
    {
      Nome: 'CLORIDRATO DE SIBUTRAMINA',
      CAS: '84485-00-7',
    },
  ],
  TipoMedicamento: 'SIMILAR INTERCAMBIAVEL',
  TipoMedicamentoComAcentuacao: 'SIMILAR INTERCAMBIÁVEL',
  FormaFarmaceutica: 'Capsula Dura',
  FormaFarmaceuticaComAcentuacao: 'Cápsula Dura',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  MaiorPreco: 40.75,
  MenorPreco: 40.75,
  PodeDispensaEletronica: false,
  Portaria344: 'LISTA B2 - Notificação de Receita B2',
  idPortaria344: 5,
  IdViaAdministracao: 0,
  CodigoATC: 'B05BB01',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'SIBUS 10 MG - Cápsula dura',
  LaboratorioPreferencia: 1,
  LME: false,
  ProdutoCorrelato: false,
  LabelFarmaco: '',
  Beneficios: [],
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_C2_TAG_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11731462,
  Posologia: 'Tomar 1 cápsula via oral',
  Quantidade: 1,
  Embalagens: ['30'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7896226500027'],
  DetalhesDispensa: [],
  IdMedicamento: 23632,
  Nome: 'ROACUTAN',
  Concentracao: '20',
  Unidade: 'MG',
  Farmacos: ['ISOTRETINOINA'],
  PrincipiosAtivos: [
    {
      Nome: 'ISOTRETINOINA',
      CAS: '4759-48-2',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Capsula Mole',
  FormaFarmaceuticaComAcentuacao: 'Cápsula Mole',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  MaiorPreco: 300.27,
  MenorPreco: 300.27,
  PodeDispensaEletronica: false,
  Portaria344: 'LISTA C2 - Notificação de Receita Especial de Retinoides Sistêmicos',
  idPortaria344: 7,
  IdViaAdministracao: 0,
  CodigoATC: 'D10BA01',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'ROACUTAN 20 MG - Cápsula mole',
  LaboratorioPreferencia: 1,
  LME: false,
  ProdutoCorrelato: false,
  LabelFarmaco: '',
  Beneficios: [],
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_C3_TAG_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11731463,
  Posologia: 'Tomar 1 cápsula via oral',
  Quantidade: 1,
  Embalagens: ['21', '14'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'ORAL',
  ImpressaoDuasVias: false,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7898957392025', '7898957392179'],
  DetalhesDispensa: [],
  IdMedicamento: 41375,
  Nome: 'REVLIMID',
  Concentracao: '5',
  Unidade: 'MG',
  Farmacos: ['LENALIDOMIDA'],
  PrincipiosAtivos: [
    {
      Nome: 'LENALIDOMIDA',
      CAS: '191732-72-6',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Capsula Dura',
  FormaFarmaceuticaComAcentuacao: 'Cápsula Dura',
  UsoInterno: true,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  MaiorPreco: 13977.6,
  MenorPreco: 0,
  PodeDispensaEletronica: false,
  Portaria344: 'LISTA C3 - Notificação de Receita Especial da Talidomida',
  idPortaria344: 8,
  IdViaAdministracao: 0,
  CodigoATC: 'L04AX04',
  ControleEspecial: false,
  MIP: false,
  TemBeneficio: false,
  Label: 'REVLIMID 5 MG - Cápsula dura',
  LaboratorioPreferencia: 1,
  LME: false,
  ProdutoCorrelato: false,
  LabelFarmaco: '',
  Beneficios: [],
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_ANABOLIC_MEDICINE = (): Medicine => ({
  idPrescricaoMedicamento: 11736128,
  Posologia: 'Injetar via intramuscular',
  Quantidade: 1,
  Embalagens: ['1', '1'],
  UsoContinuo: false,
  PermitirTroca: 0,
  FarmaciaPopular: false,
  AtivoAnvisa: true,
  ViaAdministracao: 'INTRAMUSCULAR',
  ImpressaoDuasVias: true,
  Dispensado: false,
  QuantidadeDispensada: 0,
  ListaEANS: ['7897572000056', '7895858016241'],
  DetalhesDispensa: [],
  IdMedicamento: 11721,
  Nome: 'DURATESTON',
  Concentracao: '250',
  Unidade: 'MG/ML',
  Farmacos: ['TESTOSTERONA'],
  PrincipiosAtivos: [
    {
      Nome: 'TESTOSTERONA',
      CAS: '58-22-0',
    },
  ],
  TipoMedicamento: 'NOVO',
  TipoMedicamentoComAcentuacao: 'NOVO',
  FormaFarmaceutica: 'Solucao Injetavel',
  FormaFarmaceuticaComAcentuacao: 'Solução Injetável',
  UsoInterno: true,
  ProdutoCorrelato: false,
  Antimicrobiano: false,
  idTipoAntimicrobiano: 3,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  Desconto: 0,
  LME: false,
  MaiorPreco: 11.11,
  MenorPreco: 11.11,
  PodeDispensaEletronica: true,
  Portaria344: 'LISTA C5 - Receita de Controle Especial em duas vias (CPF médico + CID paciente)',
  idPortaria344: 10,
  IdViaAdministracao: 0,
  CodigoATC: 'G03BA03',
  ControleEspecial: true,
  MIP: false,
  TemBeneficio: false,
  Label: 'DURATESTON 250 MG/ML - Solução injetável',
  LabelFarmaco: '',
  Beneficios: [],
  LaboratorioPreferencia: 1,
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});

export const DEFAULT_MEDICINE_DRUG_INTERACTIONS = (): MedicinesInteractions[] => [
  {
    medicineId: 29350,
    drugInteractions: [
      {
        name: 'ABATACEPTE',
        drugId: 1747,
        gcr: '928482',
        medicineDrugInteractions: [],
        otherInteractions: [
          {
            secondaryItemName: null,
            drugId: null,
            documentationRating: 'FAIR',
            id: '4201380',
            monographId: '4201380',
            severity: 'MAJOR',
            source: 'M',
            type: 'LAB',
            warningText: [
              'ABATACEPT may result in a falsely elevated blood glucose measurement due to assay interference with the glucose dehydrogenase pyrroloquinoline quinone (GDH-PQQ) method.',
            ],
          },
        ],
        allergyInteractions: [],
        isAllergic: false,
      },
    ],
  },
  {
    medicineId: 11103,
    drugInteractions: [
      {
        name: 'DIPIRONA',
        drugId: 541,
        gcr: '924067',
        medicineDrugInteractions: [
          {
            medicineName: 'IMENSE',
            medicineId: 30818,
            drugInteraction: [
              {
                secondaryItemName: 'IMENSE',
                drugId: 2228,
                documentationRating: 'EXCELLENT',
                id: '1210635',
                monographId: '1210635',
                severity: 'MAJOR',
                source: 'M',
                type: 'DRUG',
                warningText: [
                  'Concurrent use of NSAID and SEROTONIN NOREPINEPHRINE REUPTAKE INHIBITORS may result in an increased risk of bleeding.',
                ],
              },
            ],
            label: 'IMENSE',
          },
        ],
        otherInteractions: [
          {
            secondaryItemName: null,
            drugId: null,
            documentationRating: 'GOOD',
            id: '4096273',
            monographId: '4096273',
            severity: 'MINOR',
            source: 'M',
            type: 'LAB',
            warningText: [
              'NONSTEROIDAL ANTIINFLAMMATORY AGENTS may result in falsely positive fecal hemoccult tests due to NSAID-induced gastrointestinal bleeding.',
            ],
          },
        ],
        allergyInteractions: [],
        isAllergic: false,
      },
    ],
  },
  {
    medicineId: 30818,
    drugInteractions: [
      {
        name: 'SUCCINATO DE DESVENLAFAXINA MONOIDRATADO',
        drugId: 2228,
        gcr: '929000',
        medicineDrugInteractions: [
          {
            medicineName: 'DIPIRONA',
            medicineId: 11103,
            drugInteraction: [
              {
                secondaryItemName: 'DIPIRONA',
                drugId: 541,
                documentationRating: 'EXCELLENT',
                id: '1210635',
                monographId: '1210635',
                severity: 'MAJOR',
                source: 'M',
                type: 'DRUG',
                warningText: [
                  'Concurrent use of NSAID and SEROTONIN NOREPINEPHRINE REUPTAKE INHIBITORS may result in an increased risk of bleeding.',
                ],
              },
            ],
            label: 'DIPIRONA',
          },
        ],
        otherInteractions: [
          {
            secondaryItemName: null,
            drugId: null,
            documentationRating: 'FAIR',
            id: '3201986',
            monographId: '3201986',
            severity: 'MAJOR',
            source: 'M',
            type: 'ETHANOL',
            warningText: [
              'Concurrent use of DESVENLAFAXINE and ETHANOL may result in an increased risk of CNS effects.',
            ],
          },
          {
            secondaryItemName: null,
            drugId: null,
            documentationRating: 'GOOD',
            id: '4211919',
            monographId: '4211919',
            severity: 'MODERATE',
            source: 'M',
            type: 'LAB',
            warningText: [
              'DESVENLAFAXINE may result in a false-positive urine immunoassay phencyclidine test result due to lack of specificity of the immunoassay screening test.',
            ],
          },
          {
            secondaryItemName: null,
            drugId: null,
            documentationRating: 'GOOD',
            id: '4207457',
            monographId: '4207457',
            severity: 'MODERATE',
            source: 'M',
            type: 'LAB',
            warningText: [
              'DESVENLAFAXINE may result in a false-positive urine immunoassay amphetamine test result due to lack of specificity of the immunoassay screening test.',
            ],
          },
        ],
        allergyInteractions: [],
        isAllergic: false,
      },
    ],
  },
];

export const DEFAULT_SEVERITY_DETAILS = (): SeverityDetails[] => [
  {
    idPrimeiroMedicamento: null,
    idSegundomedicamento: null,
    severidade: 'MAJOR',
    tipo: 'LAB',
    textoAviso:
      'ABATACEPT may result in a falsely elevated blood glucose measurement due to assay interference with the glucose dehydrogenase pyrroloquinoline quinone (GDH-PQQ) method.',
  },
  {
    idPrimeiroMedicamento: null,
    idSegundomedicamento: null,
    severidade: 'MINOR',
    tipo: 'LAB',
    textoAviso:
      'NONSTEROIDAL ANTIINFLAMMATORY AGENTS may result in falsely positive fecal hemoccult tests due to NSAID-induced gastrointestinal bleeding.',
  },
  {
    idPrimeiroMedicamento: 11103,
    idSegundomedicamento: 30818,
    severidade: 'MAJOR',
    tipo: 'DRUG',
    textoAviso:
      'Concurrent use of NSAID and SEROTONIN NOREPINEPHRINE REUPTAKE INHIBITORS may result in an increased risk of bleeding.',
  },
  {
    idPrimeiroMedicamento: null,
    idSegundomedicamento: null,
    severidade: 'MAJOR',
    tipo: 'ETHANOL',
    textoAviso: 'Concurrent use of DESVENLAFAXINE and ETHANOL may result in an increased risk of CNS effects.',
  },
  {
    idPrimeiroMedicamento: null,
    idSegundomedicamento: null,
    severidade: 'MODERATE',
    tipo: 'LAB',
    textoAviso:
      'DESVENLAFAXINE may result in a false-positive urine immunoassay phencyclidine test result due to lack of specificity of the immunoassay screening test.',
  },
  {
    idPrimeiroMedicamento: null,
    idSegundomedicamento: null,
    severidade: 'MODERATE',
    tipo: 'LAB',
    textoAviso:
      'DESVENLAFAXINE may result in a false-positive urine immunoassay amphetamine test result due to lack of specificity of the immunoassay screening test.',
  },
  {
    idPrimeiroMedicamento: 30818,
    idSegundomedicamento: 11103,
    severidade: 'MAJOR',
    tipo: 'DRUG',
    textoAviso:
      'Concurrent use of NSAID and SEROTONIN NOREPINEPHRINE REUPTAKE INHIBITORS may result in an increased risk of bleeding.',
  },
];

export const LACUNA_NOT_VALID_SIGNATURE = (): LacunaDocumentValidation[] => [
  {
    id: '6747539',
    url: 'https://www.somewheretogo.com.br/',
    validation: {
      hasExpiredCertificate: false,
      hasRevokedCertificate: false,
      hasIndeterminateSignature: false,
      hasValidSignature: false,
      hasError: true,
      hasSignature: true,
      signatureDetails: [
        {
          _validationResults: {
            _errors: [
              {
                _message: ['O emissor do certificado não é confiável'],
              },
            ],
          },
        },
      ],
    },
  },
];

// como nao possui assinatura o array eh vazio
export const LACUNA_NOT_SIGNED = (): LacunaDocumentValidation[] => [
  {
    id: '6747191',
    url: 'https://www.somewheretogo.com.br/',
    validation: {
      hasError: false,
      hasExpiredCertificate: false,
      hasIndeterminateSignature: false,
      hasRevokedCertificate: false,
      hasSignature: false,
      hasValidSignature: false,
      signatureDetails: [],
    },
  },
];

export const LACUNA_VALID_SIGNATURE = (): LacunaDocumentValidation[] => [
  {
    id: '6747191',
    url: 'https://www.somewheretogo.com.br/',
    validation: {
      hasError: false,
      hasExpiredCertificate: false,
      hasIndeterminateSignature: false,
      hasRevokedCertificate: false,
      hasSignature: true,
      hasValidSignature: true,
      signatureDetails: [],
    },
  },
];

export const DEFAULT_PRINT_DOCUMENTS_URL = (): PrescriptionDocuments => ({
  documents: [
    {
      signature: '',
      url: 'https://www.somewheretogo.com.br/',
      type: 'MEDICINE',
      pdfBase64: null,
    },
  ],
});

export const DEFAULT_PRINT_DOCUMENTS_BASE64 = (): PrescriptionDocuments => ({
  documents: [
    {
      signature: 'VIDAAS',
      url: 'https://www.somewheretogo.com.br/',
      type: 'MEDICINE',
      pdfBase64: 'default base 64 just for testing',
    },
  ],
});

export const DEFAULT_PDF_LAYOUT_MODELS = (): PDFModelLayout[] => [
  {
    atualizadoEm: new Date('2022-05-12T17:44:21.567Z'),
    criadoEm: new Date('2022-05-12T17:44:21.567Z'),
    configuracoes: {
      showHeaderCrm: true,
      showHeaderDoctorName: true,
      layoutLogo: 'https://nxd-static-images.s3.amazonaws.com/c5dae2e3-86d0-4b5b-a762-82aafe771ce5',
      showFooterCrm: false,
      showFooterDoctorName: true,
      showFooterEstablishmentAddress: true,
      showFooterEstablishmentPhone: true,
      fontFamily: 'Arial, Helvetica, sans-serif',
      color: '#ef3007',
      headerTextAlign: 'left',
      footerTextAlign: 'left',
      marginBottom: '2.0',
      marginLeft: '2.0',
      marginRight: '2.0',
      marginTop: '2.0',
      showLogo: true,
      showHeaderPatientBirthDate: true,
    },
    idLayout: 1,
    idMedico: 23776,
    nome: 'Layout customizado simples 2',
    selecionado: true,
    tipo: 'SIMPLES',
  },
  {
    atualizadoEm: new Date('2022-05-12T17:44:21.567Z'),
    criadoEm: new Date('2022-05-12T17:44:21.567Z'),
    configuracoes: {
      showHeaderCrm: false,
      showHeaderDoctorName: false,
      layoutLogo: '',
      showFooterCrm: false,
      showFooterDoctorName: false,
      showFooterEstablishmentAddress: true,
      showFooterEstablishmentPhone: true,
      fontFamily: 'Arial, Helvetica, sans-serif',
      color: '#ed0909',
      headerTextAlign: 'right',
      footerTextAlign: 'right',
      marginBottom: '2.0',
      marginLeft: '2.0',
      marginRight: '2.0',
      marginTop: '2.0',
      showLogo: true,
      showHeaderPatientBirthDate: true,
    },
    idLayout: 18,
    idMedico: 23776,
    nome: 'teste3',
    selecionado: false,
    tipo: 'SIMPLES',
  },
  {
    atualizadoEm: new Date(),
    criadoEm: new Date(),
    configuracoes: {
      showHeaderCrm: false,
      showHeaderDoctorName: false,
      layoutLogo: '',
      showFooterCrm: false,
      showFooterDoctorName: false,
      showFooterEstablishmentAddress: false,
      showFooterEstablishmentPhone: false,
      fontFamily: 'Arial',
      color: 'black',
      headerTextAlign: 'left',
      footerTextAlign: 'left',
      marginBottom: '1.0',
      marginLeft: '1.0',
      marginRight: '1.0',
      marginTop: '1.0',
      showLogo: true,
      showHeaderPatientBirthDate: true,
    },
    idLayout: 27,
    idMedico: 23776,
    nome: 'teste receituario controlado',
    selecionado: false,
    tipo: 'CONTROLADO',
  },
];

export const DEFAULT_INTERACTION_EXAM = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 223,
  type: 'LAB',
  severity: 'MAJOR',
  interactionText:
    'ABATACEPT may result in a falsely elevated blood glucose measurement due to assay interference with the glucose dehydrogenase pyrroloquinoline quinone (GDH-PQQ) method.',
  firstMedicineName: 'ABATACEPTE',
  secondMedicineName: null,
  requiredAction: 'Justificativa',
  justification: '',
  prescriptionId: 6752974,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_MEDICINE = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 224,
  type: 'DRUG',
  severity: 'MAJOR',
  interactionText:
    'Concurrent use of TRAMADOL and CNS DEPRESSANTS may result in increased risk of respiratory and CNS depression.',
  firstMedicineName: 'HEMITARTARATO DE ZOLPIDEM',
  secondMedicineName: 'TRAMAL',
  requiredAction: 'Justificativa',
  justification: '',
  prescriptionId: 6752974,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_FOOD = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 226,
  type: 'FOOD',
  severity: 'MODERATE',
  interactionText: 'Concurrent use of ZOLPIDEM and FOOD may result in decreased zolpidem plasma concentrations.',
  firstMedicineName: 'HEMITARTARATO DE ZOLPIDEM',
  secondMedicineName: null,
  requiredAction: 'Notificação',
  justification: '',
  prescriptionId: 6752974,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_ETHANOL = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 227,
  type: 'ETHANOL',
  severity: 'MAJOR',
  interactionText: 'Concurrent use of ZOLPIDEM and ETHANOL may result in increased sedation.',
  firstMedicineName: 'HEMITARTARATO DE ZOLPIDEM',
  secondMedicineName: null,
  requiredAction: 'Justificativa',
  justification: '',
  prescriptionId: 6752974,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_TOBACCO = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 229,
  type: 'TOBACCO',
  severity: 'MAJOR',
  interactionText:
    'Concurrent use of CYP1A2 SUBSTRATES and TOBACCO may result in decreased exposure of CYP1A2 substrates.',
  firstMedicineName: 'CAFEINA',
  secondMedicineName: null,
  requiredAction: 'Justificativa',
  justification: '',
  prescriptionId: 6752974,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_INGREDIENT_DUPLICATION = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 235,
  type: 'INGREDIENT_DUPLICATION',
  severity: 'CONTRAINDICATED',
  interactionText:
    'An ingredient duplication has occurred.  The ingredient DIAZEPAM has been duplicated in the following products: DIAZEPAM and DIAZEPAM.',
  firstMedicineName: 'DIAZEPAM',
  secondMedicineName: null,
  requiredAction: 'Justificativa',
  justification: null,
  prescriptionId: 6752974,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_PREGNANCY = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 298,
  type: 'PREGNANCY',
  severity: 'MODERATE',
  interactionText:
    'Available evidence is inconclusive or inadequate for determining fetal risk when used in pregnant women.',
  firstMedicineName: 'CLORIDRATO DE AMIODARONA',
  secondMedicineName: null,
  requiredAction: 'Notificação',
  justification: null,
  prescriptionId: 6765432,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_LACTATION = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 299,
  type: 'LACTATION',
  severity: 'MAJOR',
  interactionText:
    'According to the American Academy of Pediatrics, Amiodarone has unknown effects and may be of concern during breast-feeding.',
  firstMedicineName: 'CLORIDRATO DE AMIODARONA',
  secondMedicineName: null,
  requiredAction: 'Justificativa',
  justification: null,
  prescriptionId: 6765432,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_INTERACTION_ALLERGY = (): PrescriptionInteractionJustifyDetail => ({
  prescriptionInteractionJustificationId: 300,
  type: 'ALLERGY',
  severity: 'CONTRAINDICATED',
  interactionText:
    'A history of hypersensitivity to the following substance has been noted for this patient: DIPYRONE.',
  firstMedicineName: 'DIPIRONA',
  secondMedicineName: null,
  requiredAction: 'Justificativa',
  justification: null,
  prescriptionId: 6765432,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const DEFAULT_JUSTIFY_INTERACTIONS = (): PrescriptionInteractionJustifyDetail[] => [
  DEFAULT_INTERACTION_EXAM(),
  DEFAULT_INTERACTION_MEDICINE(),
  DEFAULT_INTERACTION_FOOD(),
  DEFAULT_INTERACTION_ETHANOL(),
  DEFAULT_INTERACTION_TOBACCO(),
  DEFAULT_INTERACTION_INGREDIENT_DUPLICATION(),
  DEFAULT_INTERACTION_PREGNANCY(),
  DEFAULT_INTERACTION_LACTATION(),
  DEFAULT_INTERACTION_ALLERGY(),
];

export const DEFAULT_PRIMARY_COLOR = '#3D0E6B';
export const DEFAULT_SECONDARY_COLOR = '#FFB6BF';
export const DEFAULT_MEVO_WHATSAPP_NUMBER = () => '11973258051';

export const DEFAULT_CERTIFICATE = (): Certificate => ({
  name: CERTIFICATES.SOLUTI,
  imagePath: '',
  value: CERTIFICATES.SOLUTI,
  certifierStatus: CERTIFIER_STATUS.ACTIVE,
  description: 'teste de descricao',
});

export const DEFAULT_STRUCTURED_PACKING = (): StructuredPacking => ({
  Embalagem: '1',
  LabelEmbalagem: 'Label embalagem 30g',
  VolumeEmbalagem: 30,
  QuantidadeEmbalagens: 2,
  UnidadeVolumeEmbalagem: 'g',
  TipoEmbalagem: 'Frasco',
});

export const DEFAULT_LACUNA_CERTIFICATE = (prescriberCPF: string) => ({
  email: 'email@email.com',
  pkiBrazil: {
    cpf: prescriberCPF,
  },
  subjectName: 'Subject Name',
  issuerName: 'Issuer Name',
  thumbprint: 'thumbprint',
  keyUsage: {},
  validityStart: Date.now() - 1000000,
  validityEnd: Date.now() + 1000000,
  canRemove: false,
});

export const DEFAULT_RELATED_PRODUCT = (): Medicine => ({
  Beneficios: [],
  MIP: true,
  MenorPreco: 0,
  MaiorPreco: 0,
  Desconto: 0,
  TipoMedicamentoComAcentuacao: 'CORRELATO',
  TipoMedicamento: 'CORRELATO',
  PrincipiosAtivos: [],
  Farmacos: [],
  Grupo: 'GRUPO_TESTE',
  DetalhesDispensa: [],
  ListaEANS: ['7897975693343'],
  QuantidadeDispensada: 0,
  Dispensado: false,
  PermitirTroca: 0,
  idPrescricaoMedicamento: 11829449,
  CodigoATC: '',
  Concentracao: '',
  ControleEspecial: false,
  Embalagem: '',
  IdMedicamento: 47768,
  Nome: 'CREME ADCOS DERMA COMPLEX VITAMINA C 20 30G',
  ImpressaoDuasVias: false,
  Posologia: 'passar 2x ao dia',
  Quantidade: 1,
  UsoContinuo: false,
  Unidade: '',
  UsoInterno: true,
  Antimicrobiano: false,
  AntimicrobianoDescricao: 'Não é antimicrobiano',
  idTipoAntimicrobiano: 3,
  Embalagens: [''],
  FormaFarmaceutica: '',
  FormaFarmaceuticaComAcentuacao: '',
  IdViaAdministracao: 8,
  LME: false,
  Label: 'CREME ADCOS DERMA COMPLEX VITAMINA C 20 30G ',
  LabelFarmaco: '',
  AtivoAnvisa: true,
  FarmaciaPopular: false,
  PodeDispensaEletronica: true,
  ProdutoCorrelato: true,
  TemBeneficio: false,
  ViaAdministracao: 'INDEFINIDA',
  idPortaria344: 0,
  Portaria344: 'Não é Portaria 344 - Não é Portaria 344',
  QuantidadeUnidadeFormatada: '',
  Ordem: 1,
  LaboratorioPreferencia: 0,
  EmbalagensEstruturadas: [DEFAULT_STRUCTURED_PACKING()],
  EmbalagemEstruturada: DEFAULT_STRUCTURED_PACKING(),
  ParanaSemDor: false,
});
